import React,{ Component } from 'react';
import i18n from '../../../../i18n';
import { StatusForm } from '../../../utilities/Const/StatusActive';
import Input from '../../../utilities/Form/input';
import Radio from '../../../utilities/Form/radio';
import Select2 from '../../../utilities/Form/Select2';


export class Form extends Component {
    constructor(props) {
        super(props)
        this.state={
            form:{
                idParent:'',
                name:'',
                status:1,
            },
            unitCurrent:null,
            UnitText:i18n.t('Select Parent'),
            isUpdate:0
        }
        this.handler = this.handler.bind(this)
        this.handlerSelect = this.handlerSelect.bind(this)
        this.runSubmit=this.runSubmit.bind(this)
    }
   
    handler(e) {
        var key=e.target.name;
        var value=e.target.value
        this.setState({
            ...this.state, 
            form: {
                ...this.state.form,
                [key]:value
            } 
        })
    }
    handlerSelect(e,name,currentState) {
        var key=name
        var value=''
        if(e!=null){
            value=e.value
        }
        this.setState({
            ...this.state, 
            form: {
                ...this.state.form,
                [key]:value
            } 
        })
        this.setState({[currentState]:e})
    }
    runSubmit(){
       return this.state.form
    }
    renderError(name){
        const {isError,errorMessage}=this.props
        var value=''
        if(isError){
            if(errorMessage[name] !=undefined){
                value=errorMessage[name][0]
            }
        }
        return i18n.t(value);
    }
    render(){
        const {data,isNewRecord,unitList}=this.props   
        this.state.unitList=unitList     
        if(data !=null && !isNewRecord){
            if(this.state.isUpdate==0){
                this.state.form.name=data.name,
                this.state.form.idParent=data.parent_id,
                this.state.form.status=data.status
                this.state.isUpdate=1
                this.state.unitCurrent={value:data.parent_id,label:((data.parent !='')?data.parent:this.state.UnitText)}
            }
        }
        return (
            <form>
                 <Select2 
                    isClearable={true}
                    name={'idParent'}
                    onChange={(e)=>this.handlerSelect(e,"idParent","unitCurrent")}
                    options={this.state.unitList}
                    title={i18n.t("Unit")}
                    value={this.state.unitCurrent}
                    placeholder={this.state.UnitText}
                    error={this.renderError('idParent')}
                />
                <Input
                    type={"input"}
                    name={"name"}
                    title={i18n.t("Name")}
                    required
                    value={this.state.form.name}
                    handler={this.handler}
                    error={this.renderError('name')}
                />
                <Radio
                    list={StatusForm}
                    name={"status"}
                    title={i18n.t("Status")}
                    inline={false}
                    value={this.state.form.status}
                    handler={this.handler}
                    error={this.renderError('status')}
                />
            </form>
        );
    }
}

export default Form;